import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';

import { ContentAcademyModel } from '../../models/academy/content-academy.model';

import { AcademyRepository } from '../../repositories/academy.repository';

export class GetAllContentAcademyUseCase implements UseCase<void,ContentAcademyModel> {
  constructor(private repository: AcademyRepository) {}

  execute(): Observable<ContentAcademyModel> {
    return this.repository.getAllContentAcademy();
  }
}
